import { TPannellumConfig } from '../../types/panellum';

const basePath = 'https://static.treedis.com/projects/rassco';

export const pannellumConfigRassco: { [key: number]: TPannellumConfig } = {
  1: {
    hfov: 120.0,
    hfovMobile: 70.0,
    pitch: 5,
    type: 'multires',
    multiRes: {
      basePath: `${basePath}/pano/multires/1`,
      path: '/%l/%s%y_%x',
      fallbackPath: '/fallback/%s',
      extension: 'jpg',
      tileResolution: 512,
      maxLevel: 5,
      cubeResolution: 6360,
    },
    hotSpots: [
      // Building hotspots
      {
        pitch: 52.2221961827899,
        yaw: 14.287333020232655,
        type: 'info',
        createTooltipArgs: { title: 'A', type: 'building' },
      },
      {
        pitch: 35.85564130114042,
        yaw: -24.448242044376993,
        type: 'info',
        createTooltipArgs: { title: 'B', type: 'building' },
      },
      {
        pitch: 29.454945038792207,
        yaw: -5.281995260656046,
        type: 'info',
        createTooltipArgs: { title: 'C', type: 'building' },
      },
      // Scene hotspots
      {
        pitch: 22,
        yaw: 36.101431648892685,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 2',
          stem: 50,
          type: 'scene',
          sceneId: 2,
          imgSrc: `${basePath}/pano/tags/scene2.webp`,
        },
      },
      {
        pitch: 38.91183815972405,
        yaw: -4.356270307647151,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 3',
          stem: 50,
          type: 'scene',
          sceneId: 3,
          imgSrc: `${basePath}/pano/tags/scene3.webp`,
        },
      },
      // POI hotspots
      {
        pitch: 2.394201005193709,
        yaw: -165.4655719527301,
        type: 'info',
        createTooltipArgs: {
          title: 'יער חדרה',
          stem: 50,
          type: 'poi',
          cardDescription: 'יער חדרה',
          cardImageSrc: `${basePath}/pano/tags/image2.webp`,
          transportation: { car: 5, walk: 18, bicycle: 5 },
        },
      },
      {
        pitch: 3.16352098537131,
        yaw: -157.5052640213721,
        type: 'info',
        createTooltipArgs: {
          title: 'תחנת רכבת חדרה',
          stem: 50,
          type: 'poi',
          cardDescription: 'תחנת רכבת חדרה',
          cardImageSrc: `${basePath}/pano/tags/image4.webp`,
          transportation: { car: 3, walk: 11, bicycle: 3 },
        },
      },
      {
        pitch: 10,
        yaw: 85,
        type: 'info',
        createTooltipArgs: {
          title: 'קניון שערי חדרה',
          stem: 50,
          type: 'poi',
          cardDescription: 'קניון שערי חדרה',
          cardImageSrc: `${basePath}/pano/tags/image3.webp`,
          transportation: { car: 4, walk: 12, bicycle: 3 },
        },
      },
      {
        pitch: 11.379752169389334,
        yaw: 71.05609433162886,
        type: 'info',
        createTooltipArgs: {
          title: 'תחנה מרכזית חדרה',
          stem: 50,
          type: 'poi',
          cardDescription: 'תחנה מרכזית חדרה',
          cardImageSrc: `${basePath}/pano/tags/image5.webp`,
          transportation: { car: 5, walk: 13, bicycle: 5 },
        },
      },
      {
        pitch: 2.8250318128856846, // done
        yaw: -69.49425957286837,
        type: 'info',
        createTooltipArgs: {
          title: 'קאנטרי חדרה',
          stem: 50,
          type: 'poi',
          cardDescription: 'קאנטרי חדרה',
          cardImageSrc: `${basePath}/pano/tags/image1.webp`,
          transportation: { car: 2, walk: 5, bicycle: 1 },
        },
      },
    ],
  },
  2: {
    hfov: 100.0,
    pitch: -10,
    type: 'multires',
    multiRes: {
      basePath: `${basePath}/pano/multires/2`,
      path: '/%l/%s%y_%x',
      fallbackPath: '/fallback/%s',
      extension: 'jpg',
      tileResolution: 512,
      maxLevel: 4,
      cubeResolution: 3176,
    },
    hotSpots: [
      // Building hotspots
      {
        pitch: 0.4074297236616212,
        yaw: -10.170462246568427,
        type: 'info',
        createTooltipArgs: { title: 'A', type: 'building' },
      },
      {
        pitch: -9.465327094952745,
        yaw: 2.2463238212001215,
        type: 'info',
        createTooltipArgs: { title: 'B', type: 'building' },
      },
      {
        pitch: -13.891052448311733,
        yaw: -0.9357193734343525,
        type: 'info',
        createTooltipArgs: { title: 'C', type: 'building' },
      },
      // Scene hotspots
      {
        pitch: 3,
        yaw: -1.195331322066977,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 3',
          stem: 50,
          type: 'scene',
          sceneId: 3,
          imgSrc: `${basePath}/pano/tags/scene3.webp`,
        },
      },
      {
        pitch: 4.489061397203081,
        yaw: -25.690563833007275,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 1',
          stem: 50,
          type: 'scene',
          sceneId: 1,
          imgSrc: `${basePath}/pano/tags/scene1.webp`,
        },
      },
      {
        pitch: -2,
        yaw: -26,
        type: 'info',
        createTooltipArgs: {
          title: 'תחנת רכבת חדרה',
          stem: 50,
          type: 'poi',
          cardDescription: 'תחנת רכבת חדרה',
          cardImageSrc: `${basePath}/pano/tags/image4.webp`,
          transportation: { car: 3, walk: 11, bicycle: 3 },
        },
      },
      {
        pitch: -9.821819610469252,
        yaw: -152.86618058285683,
        type: 'info',
        createTooltipArgs: {
          title: 'תחנה מרכזית חדרה',
          stem: 50,
          type: 'poi',
          cardDescription: 'תחנה מרכזית חדרה',
          cardImageSrc: `${basePath}/pano/tags/image5.webp`,
          transportation: { car: 5, walk: 13, bicycle: 5 },
        },
      },
      {
        pitch: -7.0673255897633505,
        yaw: -29.432852894480106,
        type: 'info',
        createTooltipArgs: {
          title: 'יער חדרה',
          stem: 50,
          type: 'poi',
          cardDescription: 'יער חדרה',
          cardImageSrc: `${basePath}/pano/tags/image2.webp`,
          transportation: { car: 5, walk: 18, bicycle: 5 },
        },
      },
      {
        pitch: -10.96175875937999,
        yaw: -102.25225871776809,
        type: 'info',
        createTooltipArgs: {
          title: 'קניון שערי חדרה',
          stem: 50,
          type: 'poi',
          cardDescription: 'קניון שערי חדרה',
          cardImageSrc: `${basePath}/pano/tags/image3.webp`,
          transportation: { car: 4, walk: 12, bicycle: 3 },
        },
      },
      {
        pitch: -34.60353547357851, // done
        yaw: -101.3665810764777,
        type: 'info',
        createTooltipArgs: {
          title: 'קאנטרי חדרה',
          stem: 50,
          type: 'poi',
          cardDescription: 'קאנטרי חדרה',
          cardImageSrc: `${basePath}/pano/tags/image1.webp`,
          transportation: { car: 2, walk: 5, bicycle: 1 },
        },
      },
    ],
  },
  3: {
    hfov: 120,
    pitch: -30,
    type: 'multires',
    multiRes: {
      basePath: `${basePath}/pano/multires/3`,
      path: '/%l/%s%y_%x',
      fallbackPath: '/fallback/%s',
      extension: 'jpg',
      tileResolution: 512,
      maxLevel: 4,
      cubeResolution: 3176,
    },
    hotSpots: [
      // Building hotspots
      {
        pitch: -12.631656689384986,
        yaw: 15.42972436915351,
        type: 'info',
        createTooltipArgs: { title: 'A', type: 'building' },
      },
      {
        pitch: -32.64057758385797,
        yaw: -0.42757250683341197,
        type: 'info',
        createTooltipArgs: { title: 'B', type: 'building' },
      },
      {
        pitch: -23.539669997963145,
        yaw: 0.1302174565082392,
        type: 'info',
        createTooltipArgs: { title: 'C', type: 'building' },
      },
      // Scene hotspots
      {
        pitch: 4.489061397203081,
        yaw: -30,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 1',
          stem: 50,
          type: 'scene',
          sceneId: 1,
          imgSrc: `${basePath}/pano/tags/scene1.webp`,
        },
      },
      {
        pitch: 5.465514710479361,
        yaw: -1.195331322066977,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 2',
          stem: 50,
          type: 'scene',
          sceneId: 2,
          imgSrc: `${basePath}/pano/tags/scene2.webp`,
        },
      },
      {
        pitch: -33,
        yaw: -96,
        type: 'info',
        createTooltipArgs: {
          title: 'קאנטרי חדרה',
          stem: 50,
          type: 'poi',
          cardDescription: 'קאנטרי חדרה',
          cardImageSrc: `${basePath}/pano/tags/image1.webp`,
          transportation: { car: 2, walk: 5, bicycle: 1 },
        },
      },
      {
        pitch: -19.761204894210657,
        yaw: 139.39065895797467,
        type: 'info',
        createTooltipArgs: {
          title: 'יער חדרה',
          stem: 50,
          type: 'poi',
          cardDescription: 'יער חדרה',
          cardImageSrc: `${basePath}/pano/tags/image2.webp`,
          transportation: { car: 5, walk: 18, bicycle: 5 },
        },
      },
      {
        pitch: -5,
        yaw: 47,
        type: 'info',
        createTooltipArgs: {
          title: 'קניון שערי חדרה',
          stem: 50,
          type: 'poi',
          cardDescription: 'קניון שערי חדרה',
          cardImageSrc: `${basePath}/pano/tags/image3.webp`,
          transportation: { car: 4, walk: 12, bicycle: 3 },
        },
      },
      {
        pitch: -10,
        yaw: 157,
        type: 'info',
        createTooltipArgs: {
          title: 'תחנת רכבת חדרה',
          stem: 50,
          type: 'poi',
          cardDescription: 'תחנת רכבת חדרה',
          cardImageSrc: `${basePath}/pano/tags/image4.webp`,
          transportation: { car: 3, walk: 11, bicycle: 3 },
        },
      },
      {
        pitch: -6.2552484178641174,
        yaw: 17,
        type: 'info',
        createTooltipArgs: {
          title: 'תחנה מרכזית חדרה',
          stem: 50,
          type: 'poi',
          cardDescription: 'תחנה מרכזית חדרה',
          cardImageSrc: `${basePath}/pano/tags/image5.webp`,
          transportation: { car: 5, walk: 13, bicycle: 5 },
        },
      },
    ],
  },
};
